<template>
  <v-container>
    <static-page-content uri="/static/pages/auth" />
    <static-page-content v-if="!$route.params.method" uri="/static/pages/methods" />
    <v-card v-else>
      <v-card-title>
        <div v-html="url" :class="['subheading', 'font-weight-light']" />
        <v-spacer />
        <v-chip :class="['hidden-sm-and-down']" :color="$config.colors.primary">{{ httpMethod }}</v-chip>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-alert :value="true" outline :color="$config.colors.primary" :class="['mb-4']" icon="mdi-information">
          <static-page-content :uri="`/static/pages/methods-${$route.params.method}`" />
        </v-alert>
        <section-header v-if="$route.params.method === 'search'" :class="['mt-4']">{{ $lang.searchBandcamp }}</section-header>
        <bc-search v-if="$route.params.method === 'search'" :class="['mb-4']" />
        <section-header>{{ $lang.header }}</section-header>
        <code-chunk :class="['mb-4']">'X-Api-Key':&nbsp;'<router-link :class="[`${$config.colors.primary}--text`]" :title="$lang.getApiKey" to="/auth" v-html="$lang.yourApiKey" />'</code-chunk>
        <section-header>{{ $lang.requestBody }}</section-header>
        <code-chunk>{{ postData }}</code-chunk>
        <v-alert :value="true" outline :color="$config.colors.primary" icon="mdi-information" :class="['mt-4']">
          <div v-html="$lang.requestBodyInstructions" />
        </v-alert>
        <section-header :class="['mt-4']">{{ $lang.axiosExample }}</section-header>
        <code-chunk>// set the X-Api-Key header to Axios' defaults (or you can pass it with each request)
this.$http.defaults.headers.common = {
  'X-Api-Key': '<router-link :class="[`${$config.colors.primary}--text`]" :title="$lang.getApiKey" to="/auth" v-html="$lang.yourApiKey" />'
}
// make the request, handle the response and catch errors
this.$http({
  url: '{{ $config.apiRoot }}/{{ $route.params.method }}',
  method: 'POST',
  data: {{ postData }}
}).then(response => {
  // handle response
  console.log(response.data)
}).catch(error => {
  // handle error
  console.error(error)
})</code-chunk>
        <section-header :class="['mt-4']">{{ $lang.cUrlExample }}</section-header>
        <code-chunk>curl --location --request GET '{{ $config.apiRoot }}/{{ $route.params.method }}' \
--header 'X-Api-Key: <router-link :class="[`${$config.colors.primary}--text`]" :title="$lang.getApiKey" to="/auth" v-html="$lang.yourApiKey" />' \
--data-raw '{{ postData }}'</code-chunk>
        <section-header :class="['mt-4']">{{ $lang.response }}</section-header>
        <code-chunk>{{ payload }}</code-chunk>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: 'MethodsPage',
  data () {
    return {
      method: null,
      payload: null,
      url: null,
      httpMethod: null,
      postData: null,
      artist: this.$config.methods.artist.artist,
      album: this.$config.methods.album.album,
      track: this.$config.methods.track.track,
      search: this.$config.methods.search,
      player: this.$config.methods.player
    }
  },
  watch: {
    '$route.params' () {
      this.callMethod()
    }
  },
  mounted () {
    this.callMethod()
  },
  methods: {
    resetData () {
      this.payload = null
      this.method = null
      this.httpMethod = null
      this.url = null
      this.postData = null
    },
    callMethod () {
      const method = this.$route.params.method
      if (method) {
        const artist = this.artist
        this.url = `${this.$config.apiRoot}/${method}`
        this.httpMethod = 'POST'
        switch (method) {
          case 'artist':
            this.postData = {artist}
            break
          case 'album':
            this.postData = {
              artist,
              album: this.album
            }
            break
          case 'track':
            this.postData = {
              artist,
              track: this.track
            }
            break
          case 'search':
            this.postData = this.search
            break
          case 'player':
            this.postData = this.player
            break
        }
        this.$http({
          url: this.url,
          method: this.httpMethod,
          data: this.postData
        }).then(response => {
          this.payload = response.data.data
        }).catch(error => {
          console.error(error)
        })
      } else {
        this.resetData()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/methods-page.vue